import styles from "./Evaluation.module.css";
import { useState } from "react";
import { BlueButton } from "@react-solutions-ui/findmore-ui";
import AddNoteSidePanel from "../../../../components/ui/NotePanel/AddNotePanel";
import { Modal } from "@react-solutions-ui/findmore-ui";
import { ITeamLeaderOwnEvaluation } from "../../Interfaces/IHomeInterface";
import AddNotesIcon from "../../../../assets/icons/addNotesIcon.svg";
import { useNavigate } from "react-router-dom";
import { Empty } from "antd";

interface Props {
  data: ITeamLeaderOwnEvaluation[];
  loading?: boolean;
  onStartEvaluation: () => void;
  onShowToast: (msg: string) => void;
  title?: string;
  subtitle?: string;
}

export default function EvaluateTeamList({
  data,
  title = "AVALIAR A MINHA EQUIPA",
  subtitle = "Avalia e acompanha a tua equipa.",
}: Props) {
  const navigate = useNavigate();
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [successModal, setSuccessModal] = useState<{
    open: boolean;
    message: string;
  }>({ open: false, message: "" });

  const calcDaysRemaining = (endDate: string, addDays: boolean = false) => {
    const end = new Date(endDate);
    if (addDays) {
      end.setDate(end.getDate() + 1);
    }
    const now = new Date();
    const diff = Math.ceil(
      (end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
    );
    return diff;
  };

  const getDaysRemainingText = (endDate: string) => {
    const diff = calcDaysRemaining(endDate, true);
    if (diff > 0) return `${diff} dias restantes`;
    return "Prazo expirado";
  };

  const getDaysUntil = (nextEvaluationDate: string) => {
    const diff = calcDaysRemaining(nextEvaluationDate, false);
    if (diff > 0) return `Inicia em ${diff} dias`;
    return "";
  };

  // Get data in format DD/MM/YYYY
  const getDate = (date: string) => {
    return new Date(date).toLocaleDateString("pt-BR");
  };

  return (
    <div className={styles.container}>
      <div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      {data.length === 0 ? (
        <div className={styles.emptyWrapper}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Sem avaliações da tua equipa"
          />
        </div>
      ) : (
        data.map((item) => {
          const daysRemaining = calcDaysRemaining(item.endDate, true);
          const nextEvaluationDaysRemaining = item.nextEvaluationDate
            ? calcDaysRemaining(item.nextEvaluationDate, false)
            : null;

          return (
            <div key={item.employeeId} className={styles.card}>
              <div className={styles.info}>
                {item.nextEvaluationDate &&
                nextEvaluationDaysRemaining !== null &&
                nextEvaluationDaysRemaining > 0 ? (
                  nextEvaluationDaysRemaining <= 30 ? (
                    <span className={styles.daysUntil}>
                      {getDaysUntil(item.nextEvaluationDate).toUpperCase()}
                    </span>
                  ) : (
                    <span className={styles.daysUntil}>
                      Início da avaliação: {getDate(item.nextEvaluationDate)}
                    </span>
                  )
                ) : (
                  daysRemaining <= 5 && (
                    <span className={styles.daysLeft}>
                      {getDaysRemainingText(item.endDate).toUpperCase()}
                    </span>
                  )
                )}
                <div className={styles.person}>
                  <button
                    className={`${styles.name} ${styles.clickableName}`}
                    onClick={() =>
                      navigate(`/profile-team/${item.evaluatedEmployeeId}`)
                    }
                  >
                    {item.personName}
                  </button>
                  <span className={styles.role}>{item?.areaName}</span>
                </div>
              </div>

              <div className={styles.divider} />

              <div className={styles.actions}>
                <button
                  type="button"
                  className={styles.addNote}
                  onClick={() => {
                    setSelectedUser(item.personName);
                    setSelectedEmployeeId(item.evaluatedEmployeeId);
                    setShowSidePanel(true);
                  }}
                >
                  <img src={AddNotesIcon} alt="" className={styles.addNoteIcon} />
                  Adicionar Nota
                </button>

                {(item.endDate ||
                  (item.nextEvaluationDate &&
                    nextEvaluationDaysRemaining !== null &&
                    nextEvaluationDaysRemaining <= 30)) && (
                  <BlueButton
                    text="AVALIAR"
                    onClick={() =>
                      navigate(`/questionnaire?id=${item.evaluatorId}`)
                    }
                    className={styles.evaluateBtn}
                    disabled={item.nextEvaluationDate !== undefined}
                  />
                )}
              </div>
            </div>
          );
        })
      )}

      {showSidePanel && (
        <AddNoteSidePanel
          user={selectedUser}
          employeeId={selectedEmployeeId}
          onClose={() => setShowSidePanel(false)}
          onSuccess={(msg) => {
            setSuccessModal({
              open: true,
              message: msg,
            });
          }}
        />
      )}

      {successModal.open && (
        <Modal
          title="SUCESSO"
          type="info"
          onCloseModal={() => setSuccessModal({ ...successModal, open: false })}
          closeModalLabel="FECHAR"
        >
          {successModal.message}
        </Modal>
      )}
    </div>
  );
}
